import { type PropsWithChildren, useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "@/providers/theme-provider";
import { useUIStore } from "@/store/ui-store";

/** Reflect the user's "Reduce motion" preference (set on /profile) onto the
 * document so the CSS rule in index.css can near-zero animation/transition
 * durations app-wide. */
function ReduceMotionEffect() {
  const reduceMotion = useUIStore((s) => s.reduceMotion);
  useEffect(() => {
    document.documentElement.dataset.reduceMotion = reduceMotion ? "true" : "false";
  }, [reduceMotion]);
  return null;
}

/**
 * Single composition point for app-wide providers (theme, toasts, future
 * query/i18n providers). Keeps App.tsx focused on routing.
 */
export function AppProviders({ children }: PropsWithChildren) {
  return (
    <ThemeProvider>
      <ReduceMotionEffect />
      {children}
      <Toaster richColors position="bottom-right" />
    </ThemeProvider>
  );
}
